import React, { ReactNode, useRef } from "react";
import Header from "./Header/Header";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import styles from "./Layout.module.scss";

export default function NotFound({ children }: { children: ReactNode }) {
    const isSmallScreen = useMediaQuery('(max-width: 1023px)');
    return (
        <div className={styles.layout}>
            <Header />
            <h2>404: Page Not Found</h2>
        </div>
    );
}
